import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { IonButton, IonButtons, IonHeader, IonToolbar } from '@ionic/angular/standalone';

import { DeviceService } from '@core/device';
import { I18nPipe } from '@core/i18n';

import { IconComponent } from '@shared/icon';

import { NotificationsComponent } from './notifications/notifications.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { SearchComponent } from './search/search.component';

@Component({
  selector: 'ml-shell-header',
  imports: [
    NotificationsComponent,
    ProfileMenuComponent,
    SearchComponent,
    IconComponent,
    I18nPipe,
    IonButton,
    IonButtons,
    IonHeader,
    IonToolbar,
  ],
  host: {
    class: 'ml-shell-header',
    '[class.platform-android]': 'device.isAndroid()',
    '[class.platform-ios]': 'device.isIos()',
    '[class.tablet-layout]': 'device.isTabletUI()',
    '[class.desktop-layout]': 'device.isDesktopUI()',
  },
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellHeaderComponent {
  collapsed = input(false);
  menuToggle = output<void>();

  protected readonly device = inject(DeviceService);

  protected onMenuToggle(): void {
    this.menuToggle.emit();
  }
}
